var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"risk-score column",class:_vm.issue.severity.toLowerCase()},[_c('span',[_vm._v(_vm._s(_vm.formatRiskScore))])])
}
var staticRenderFns = []

export { render, staticRenderFns }